import { hasOwnProperty } from "@core/utils/type-utils";

export interface CognitoError {
	code: string;
	message: string;
}

export function isCognitoError(error: unknown): error is CognitoError {
	if (error === null || error === undefined || typeof error !== "object") {
		return false;
	}

	if (!hasOwnProperty(error, "code") || typeof error.code !== "string") {
		return false;
	}

	if (!hasOwnProperty(error, "message") || typeof error.message !== "string") {
		return false;
	}
	return true;
}

export enum CognitoErrorCode {
	NotAuthorizedException = "NotAuthorizedException",
	UserNotFoundException = "UserNotFoundException",
	UserNotConfirmedException = "UserNotConfirmedException",
	InvalidParameterException = "InvalidParameterException",
	CodeMismatchException = "CodeMismatchException",
	ExpiredCodeException = "ExpiredCodeException",
	LimitExceededException = "LimitExceededException",
	UsernameExistsException = "UsernameExistsException",
	NetworkErrorException = "NetworkError",
}

export enum CognitoErrorMessage {
	PasswordAttemptsExceeded = "Password attempts exceeded",
	AlreadyConfirmed = "Current status is CONFIRMED",
}
